var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dash-root"}},_vm._l((_vm.dashparts),function(dashpart,index){return _c('admin-create-dash-component',{key:index,staticClass:"panel panel-flat",attrs:{"part":dashpart}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }